import { BlankSlate } from "@msuite/ui/blank-slate";
import { ContentCard } from "@msuite/ui/content-card";
import { TextInput } from "@msuite/ui/form";
import { useSearchForm } from "@msuite/ui/hooks";
import type { IconType } from "@msuite/ui/icons";

/** Props Interface */
interface CapacityResourceListProps {
	title: string;
	icon: IconType;
	searchKey: string;
}

/**
 * A placeholder list for one of the panel's entities. Every segment still draws the same card,
 * because none of them has a query yet — the one that gets its own hook, cards and drag payload
 * moves into a file of its own and stops going through here.
 */
export function CapacityResourceList({ title, icon, searchKey }: CapacityResourceListProps) {
	/** Hooks */
	const searchForm = useSearchForm(searchKey);

	/** Render */
	return (
		<ContentCard
			title={title}
			icon={icon}
			contentClassName="v-stack flex-1 min-h-0 overflow-y-auto"
			className="h-full overflow-hidden"
			variant="plain"
		>
			<div className="p-1">
				<div {...searchForm.getSearchInputWrapperProps()}>
					<TextInput {...searchForm.getSearchInputProps()} />
				</div>
			</div>
			<BlankSlate withBorder />
		</ContentCard>
	);
}
